// "3 quiet channels and 1 blocked person" — degrades to the non-zero half,
// null when both are zero. Shared by the reply bar ("used for …") and the
// reply dialog ("Right now that covers …").
export function coverageText(quiet: number, blocked: number): string | null {
  const parts: string[] = [];
  if (quiet > 0) parts.push(`${quiet} quiet ${quiet === 1 ? "channel" : "channels"}`);
  if (blocked > 0) parts.push(`${blocked} blocked ${blocked === 1 ? "person" : "people"}`);
  return parts.length > 0 ? parts.join(" and ") : null;
}
